export default function ($routeSegmentProvider) {
  "ngInject";

  $routeSegmentProvider
    .when('/maintenance', 'maintenance')

    .segment('maintenance', {
      access: {requireLogin: false},
      template: '<maintenance></maintenance>',
      loadModule: () => {
        return import(/* webpackChunkName: "maintenance.module" */ "./maintenance.module");
      }
    });

}
